import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/Core/services/language.service';

@Component({
  selector: 'app-dropdown-input',
  templateUrl: './dropdown-input.component.html',
  styleUrls: ['./dropdown-input.component.scss'],
})
export class DropdownInputComponent implements OnInit {
  @Input('data') data: any[] = [];
  @Input('text') text: string = 'text';
  @Input('value') value: string = 'value';
  @Input() currentValue: any;
  @Output() currentValueChange: EventEmitter<any> = new EventEmitter<any>();
  rand = Math.random();
  state = false;
  searchText = '';
  constructor() {}

  ngOnInit(): void {
    if (this.data?.length && !this.currentValue)
      this.currentValue = this.data[0];
    this.currentValueChange.emit(this.currentValue);
  }

  open() {
    document.getElementById(`cet-input-${this.rand}`)?.focus();
    let el = document.getElementById(`cet-ddM-${this.rand}`);
    if (el) {
      let rect = el.getBoundingClientRect();
      let space = window.innerHeight - (rect.top || 0);
      let displacement = (this.data?.length + 2) * 45;
      displacement = displacement > 200 ? 200 : displacement;
      if (space < displacement) {
        el!.style.top = `-${displacement}px`;
      }
      el?.classList.add('expanded');

      this.state = true;
    }
  }

  close() {
    setTimeout(() => {
      let btn = document.getElementById(`cet-input-${this.rand}`)?.blur;
      let el = document.getElementById(`cet-ddM-${this.rand}`);
      el?.classList.remove('expanded');
      if (el) el.style.top = '';
      this.state = false;
    }, 50);
  }

  toggle() {
    if (this.state) {
      this.close();
    } else {
      this.open();
    }
  }

  Select(item: any) {
    this.currentValue = item;
    this.currentValueChange.emit(item);
  }
}
